import React from 'react'
import { SectionLayoutDialog } from 'shared'

import { InstallmentCard } from './components'
import { useStyles } from './InstallmentsDialog.style'

const InstallmentsDialog = ({ open, onClose, inscription }) => {
  const classes = useStyles()

  const installmentOptions = [...inscription.saleOrder.payments]
    .filter((x) => !!x.installment)
    .sort((a, b) => a.installment.number - b.installment.number)

  return (
    <SectionLayoutDialog
      title='Plan de cuotas'
      open={open}
      onClose={onClose}
      className={classes.dialog}>
      <div className={classes.container}>
        {installmentOptions.map((option) => (
          <InstallmentCard key={option.id} payment={option} />
        ))}
      </div>
    </SectionLayoutDialog>
  )
}

export default InstallmentsDialog
